var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMastercard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 23,
    viewBox: "0 0 38 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3827 19.8489C17.4264 21.4707 14.8889 22.4498 12.116 22.4498C5.92878 22.4498 0.913086 17.5753 0.913086 11.5623C0.913086 5.5493 5.92878 0.674805 12.116 0.674805C14.8889 0.674805 17.4264 1.65386 19.3827 3.27568C21.339 1.65386 23.8765 0.674805 26.6494 0.674805C32.8366 0.674805 37.8523 5.5493 37.8523 11.5623C37.8523 17.5753 32.8366 22.4498 26.6494 22.4498C23.8765 22.4498 21.339 21.4707 19.3827 19.8489Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3826 19.8489C21.7913 17.852 23.3187 14.8805 23.3187 11.5623C23.3187 8.24413 21.7913 5.27265 19.3826 3.27568C21.3388 1.65386 23.8764 0.674805 26.6493 0.674805C32.8365 0.674805 37.8522 5.5493 37.8522 11.5623C37.8522 17.5753 32.8365 22.4498 26.6493 22.4498C23.8764 22.4498 21.3388 21.4707 19.3826 19.8489Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3826 19.8486C21.7914 17.8516 23.3187 14.8801 23.3187 11.562C23.3187 8.24382 21.7914 5.27236 19.3826 3.27539C16.9739 5.27236 15.4465 8.24382 15.4465 11.562C15.4465 14.8801 16.9739 17.8516 19.3826 19.8486Z",
    fill: "#FF5E00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mastercard.d4928951997421771346a0522559e595.svg";